// <s-price-countdown seconds="180"> counts down to the next price refresh (m:ss) and loops.
// Optional [data-countdown-ring] (an SVG circle with pathLength="100") drains as time passes.
// The value is aria-hidden so screen readers are not interrupted every second.
class PriceCountdown extends HTMLElement {
  #timer = 0;
  #remaining = 0;

  connectedCallback() {
    this.#remaining = this.#total;
    this.#render();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  get #total() {
    const value = parseInt(this.getAttribute('seconds') || '180', 10);
    return Number.isFinite(value) && value > 0 ? value : 180;
  }

  #tick() {
    this.#remaining -= 1;
    if (this.#remaining < 0) {
      this.#remaining = this.#total;
      window.dispatchEvent(new CustomEvent('gv:price-refresh'));
    }
    this.#render();
  }

  #render() {
    const minutes = Math.floor(this.#remaining / 60);
    const seconds = String(this.#remaining % 60).padStart(2, '0');
    const output = this.querySelector('[data-countdown-value]');
    if (output) output.textContent = `${minutes}:${seconds}`;
    const ring = this.querySelector('[data-countdown-ring]');
    if (ring) ring.style.strokeDashoffset = String(100 - (this.#remaining / this.#total) * 100);
  }
}

if (!customElements.get('s-price-countdown')) customElements.define('s-price-countdown', PriceCountdown);
